//homeSlider.js
import request from '@/utils/request';

export function getHomeSlider() {
  return request({
    url: '/v1/slide_info',
    method: 'get',
  });
}
